import Image from 'next/future/image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useQueryParams from '../../../../../hooks/useQueryParams';
import { getLangCountry } from '../../../../../helpers/languages';
import PopupShippingUsPdp from '@/components/v2/PopupShippingUsPdp';
import { useShippingRate } from '@/hooks/use-shipping-rate';

interface Props {
  madeIn: String;
}

const Delivery: React.FC<Props> = ({ madeIn }) => {
  const { t } = useTranslation();
  const { data: { rate, currencySymbol } = {}, isLoading } = useShippingRate();

  const [query] = useQueryParams();
  const { country } = getLangCountry(query);
  return (
    <ul className="space-y-2 pt-4">
      {country.toLowerCase() == 'us' && madeIn == 'us' && (
        <li className="flex items-center space-x-4">
          <Image
            src="/img/us-flag.png"
            alt="Made in USA"
            height={26}
            width={26}
          />

          <p className="text-sm font-medium tracking-wide">
            {t('P_PDP.OVERVIEW.DELIVERY.MADE_IN_USA')}
          </p>
        </li>
      )}
      {rate?.free !== -1 && (
        <li className="flex items-center space-x-4">
          <Image
            src="/v2/product/delivery.svg"
            alt="Delivery"
            height={26}
            width={26}
          />

          <p className="text-sm font-medium tracking-wide">
            {t('P_PDP.OVERVIEW.DELIVERY.FREE').replace(
              '%s',
              `${rate?.free}${currencySymbol}`
            )}
          </p>
        </li>
      )}

      <li className="flex items-center space-x-4">
        <Image
          src="/v2/product/returns.svg"
          alt="Returns"
          height={26}
          width={26}
        />

        <p className="text-sm font-medium tracking-wide">
          {country.toLowerCase() !== 'us'
            ? t('P_PDP.OVERVIEW.DELIVERY.2')
            : t('P_PDP.OVERVIEW.DELIVERY_US.2')}
        </p>
      </li>

      <li className="flex items-center space-x-4">
        <Image
          src="/v2/product/time.svg"
          alt="Time"
          height={20}
          width={20}
          className="ml-1.5"
        />

        <div className="text-sm font-medium tracking-wide">
          {country.toLowerCase() === 'us' ? (
            <PopupShippingUsPdp />
          ) : (
            t('P_PDP.OVERVIEW.DELIVERY.3')
          )}
        </div>
      </li>
    </ul>
  );
};

export default Delivery;
